import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { deepCopy } from '../utils/lodashUtils';

export default class AppRepository {
  isLoadingArray$ = new BehaviorSubject([]);

  handleOpenLoading = () => {
    const isLoadingArray = deepCopy(this.isLoadingArray$.getValue() || []);
    isLoadingArray.push(true);

    this.isLoadingArray$.next(isLoadingArray);
  };

  handleCloseLoading = () => {
    const isLoadingArray = deepCopy(this.isLoadingArray$.getValue() || []);
    isLoadingArray.pop();

    this.isLoadingArray$.next(isLoadingArray);
  };

  get isLoading$() {
    return this.isLoadingArray$.pipe(map((isLoadingArray) => isLoadingArray.length > 0));
  }
}
